<template>
  <div class="withdrawal">
    <div class="log-card">
      <div class="page-header">
        <span class="page-title">退会申请</span>
        <div class="action-buttons">
          <el-button size="mini" type="warning" @click="downloadForm">下载退会申请表</el-button>
          <el-button size="mini" type="warning" @click="saveForm">保存草稿</el-button>
          <el-button size="mini" type="warning" @click="submitForm">提交审核</el-button>
          <el-button size="mini" type="warning" @click="showProgress">审核进度</el-button>
        </div>
      </div>
      
      <div class="form-container" id="withdrawalForm">
        <div class="form-header">
          <div class="header-line1">攀枝花东区社会工作协会退会申请表</div>
        </div>
        <table class="application-table">
          <tbody>
            <tr>
              <td class="label">姓名</td>
              <td colspan="2"><input type="text" v-model="form.name"></td>
              <td class="label">性别</td>
              <td colspan="2"><input type="text" v-model="form.gender"></td>
            </tr>
            <tr>
              <td class="label">所在单位</td>
              <td colspan="2"><input type="text" v-model="form.employer"></td>
              <td class="label">职务</td>
              <td colspan="2"><input type="text" v-model="form.position"></td>
            </tr>
            <tr>
              <td class="label">退会原因</td>
              <td colspan="5">
                <textarea v-model="form.reason" rows="4"></textarea>
              </td>
            </tr>
            <tr>
              <td class="label">对协会今后发展的建议</td>
              <td colspan="5">
                <textarea v-model="form.suggestions" rows="4"></textarea>
              </td>
            </tr>
            <tr>
              <td class="label">申请人<br/>签名</td>
              <td colspan="5">
                <div class="signature-section">
                  <div class="signature-row">
                    <img v-if="form.applicantSignature" :src="form.applicantSignature" class="signature-image" @click="openApplicantSignatureDialog"/>
                    <span v-else class="signature-placeholder" @click="openApplicantSignatureDialog"></span>
                    <input type="text" v-model="form.year" class="date-input"/>年<input type="text" v-model="form.month" class="date-input"/>月<input type="text" v-model="form.day" class="date-input"/>日
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="label">市社协<br/>审批意见</td>
              <td colspan="5">
                <div class="signature-section">
                  <div class="signature-row">
                    <input type="text" v-model="form.approvalYear" class="date-input"/>年<input type="text" v-model="form.approvalMonth" class="date-input"/>月<input type="text" v-model="form.approvalDay" class="date-input"/>日
                  </div>
                  <div class="signature-row">（协会公章）</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <el-dialog title="审核进度" :visible.sync="dialogVisible" width="600px">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in progressData"
          :key="index"
          :timestamp="activity.timestamp"
          :color="activity.color">
          {{activity.content}}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>

    <el-dialog title="申请人手写签名" :visible.sync="applicantSignatureDialogVisible" width="400px" :before-close="handleApplicantSignatureDialogClose">
      <div class="signature-dialog-content">
        <canvas ref="applicantSignatureCanvas" width="350" height="150" @mousedown="startApplicantDrawing" @mousemove="drawApplicant" @mouseup="stopApplicantDrawing" @mouseleave="stopApplicantDrawing" class="signature-dialog-canvas"></canvas>
        <div class="signature-dialog-buttons">
          <el-button @click="clearApplicantSignature" size="small">取消</el-button>
          <el-button @click="saveApplicantSignature" type="primary" size="small">保存</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="协会负责人手写签名" :visible.sync="leaderSignatureDialogVisible" width="400px" :before-close="handleLeaderSignatureDialogClose">
      <div class="signature-dialog-content">
        <canvas ref="leaderSignatureCanvas" width="350" height="150" @mousedown="startLeaderDrawing" @mousemove="drawLeader" @mouseup="stopLeaderDrawing" @mouseleave="stopLeaderDrawing" class="signature-dialog-canvas"></canvas>
        <div class="signature-dialog-buttons">
          <el-button @click="clearLeaderSignature" size="small">取消</el-button>
          <el-button @click="saveLeaderSignature" type="primary" size="small">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return {
      dialogVisible: false,
      applicantSignatureDialogVisible: false,
      leaderSignatureDialogVisible: false,
      isApplicantDrawing: false,
      isLeaderDrawing: false,
      applicantCtx: null,
      leaderCtx: null,
      applicationDate: '',
      form: {
        name: '',
        gender: '',
        birthDate: '',
        employer: '',
        position: '',
        phone: '',
        email: '',
        idCard: '',
        reason: '',
        suggestions: '',
        applicantSignature: '',
        year: '',
        month: '',
        day: '',
        approvalOpinion: '',
        leaderSignature: '',
        approvalYear: '',
        approvalMonth: '',
        approvalDay: ''
      },
      progressData: [
        {
          content: '提交退会申请',
          timestamp: '2024-01-10 10:00',
          color: '#409EFF'
        },
        {
          content: '审核中',
          timestamp: '2024-01-11 14:30',
          color: '#E6A23C'
        }
      ]
    }
  },
  created(){
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    this.applicationDate = `${year}年${month}月${day}日`
    this.loadSavedForm()
  },
  methods:{
    openApplicantSignatureDialog(){
      this.applicantSignatureDialogVisible = true
      this.$nextTick(() => {
        this.initApplicantCanvas()
      })
    },
    handleApplicantSignatureDialogClose(done){
      this.applicantSignatureDialogVisible = false
      done()
    },
    initApplicantCanvas(){
      const canvas = this.$refs.applicantSignatureCanvas
      if(canvas){
        this.applicantCtx = canvas.getContext('2d')
        this.applicantCtx.strokeStyle = '#000'
        this.applicantCtx.lineWidth = 2
        this.applicantCtx.lineCap = 'round'
        this.applicantCtx.clearRect(0, 0, canvas.width, canvas.height)
      }
    },
    startApplicantDrawing(e){
      this.isApplicantDrawing = true
      const canvas = this.$refs.applicantSignatureCanvas
      const rect = canvas.getBoundingClientRect()
      this.applicantCtx.beginPath()
      this.applicantCtx.moveTo(e.clientX - rect.left, e.clientY - rect.top)
    },
    drawApplicant(e){
      if(!this.isApplicantDrawing) return
      const canvas = this.$refs.applicantSignatureCanvas
      const rect = canvas.getBoundingClientRect()
      this.applicantCtx.lineTo(e.clientX - rect.left, e.clientY - rect.top)
      this.applicantCtx.stroke()
    },
    stopApplicantDrawing(){
      this.isApplicantDrawing = false
    },
    clearApplicantSignature(){
      const canvas = this.$refs.applicantSignatureCanvas
      this.applicantCtx.clearRect(0, 0, canvas.width, canvas.height)
    },
    saveApplicantSignature(){
      const canvas = this.$refs.applicantSignatureCanvas
      const dataURL = canvas.toDataURL()
      this.form.applicantSignature = dataURL
      this.applicantSignatureDialogVisible = false
      this.$message.success('签名已保存')
    },
    openLeaderSignatureDialog(){
      this.leaderSignatureDialogVisible = true
      this.$nextTick(() => {
        this.initLeaderCanvas()
      })
    },
    handleLeaderSignatureDialogClose(done){
      this.leaderSignatureDialogVisible = false
      done()
    },
    initLeaderCanvas(){
      const canvas = this.$refs.leaderSignatureCanvas
      if(canvas){
        this.leaderCtx = canvas.getContext('2d')
        this.leaderCtx.strokeStyle = '#000'
        this.leaderCtx.lineWidth = 2
        this.leaderCtx.lineCap = 'round'
        this.leaderCtx.clearRect(0, 0, canvas.width, canvas.height)
      }
    },
    startLeaderDrawing(e){
      this.isLeaderDrawing = true
      const canvas = this.$refs.leaderSignatureCanvas
      const rect = canvas.getBoundingClientRect()
      this.leaderCtx.beginPath()
      this.leaderCtx.moveTo(e.clientX - rect.left, e.clientY - rect.top)
    },
    drawLeader(e){
      if(!this.isLeaderDrawing) return
      const canvas = this.$refs.leaderSignatureCanvas
      const rect = canvas.getBoundingClientRect()
      this.leaderCtx.lineTo(e.clientX - rect.left, e.clientY - rect.top)
      this.leaderCtx.stroke()
    },
    stopLeaderDrawing(){
      this.isLeaderDrawing = false
    },
    clearLeaderSignature(){
      const canvas = this.$refs.leaderSignatureCanvas
      this.leaderCtx.clearRect(0, 0, canvas.width, canvas.height)
    },
    saveLeaderSignature(){
      const canvas = this.$refs.leaderSignatureCanvas
      const dataURL = canvas.toDataURL()
      this.form.leaderSignature = dataURL
      this.leaderSignatureDialogVisible = false
      this.$message.success('签名已保存')
    },
    loadSavedForm(){
      const savedForm = localStorage.getItem('withdrawalApplicationForm')
      if(savedForm){
        this.form = JSON.parse(savedForm)
      }
    },
    saveForm(){
      localStorage.setItem('withdrawalApplicationForm', JSON.stringify(this.form))
      this.$message.success('表单已保存')
    },
    submitForm(){
      if(!this.form.name || !this.form.idCard || !this.form.phone){
        this.$message.warning('请填写必填信息（姓名、身份证号、联系电话）')
        return
      }
      this.$message.success('申请已提交，请等待审核')
      localStorage.removeItem('withdrawalApplicationForm')
      this.progressData.push({
        content: '已提交审核',
        timestamp: new Date().toLocaleString(),
        color: '#67C23A'
      })
    },
    showProgress(){
      this.dialogVisible = true
    },
    downloadForm(){
      const element = document.getElementById('withdrawalForm')
      const printWindow = window.open('', '_blank')
      const htmlContent = '<html><head><title>退会申请表</title><style>' +
        'body { font-family: SimSun, serif; padding: 20px; }' +
        '.form-header { margin-bottom: 20px; }' +
        '.header-line1 { text-align: center; font-size: 28px; color: #666667; margin-bottom: 10px; }' +
        '.header-line3 { font-size: 16px; color: #333; text-align: left; }' +
        '.date-row { position: relative; display: flex; justify-content: flex-start; }' +
        '.date-row span:last-child { position: absolute; left: 60%; }' +
        '.text { text-indent: 2em; }' +
        'table { width: 100%; border-collapse: collapse; }' +
        'td { border: 1px solid #000; padding: 10px; vertical-align: middle; height: 40px; font-size: 16px; }' +
        'td.label { font-weight: bold; color: #333; text-align: left; border: 1px solid #000; }' +
        'input, select, textarea { width: 100%; padding: 5px; border: none; font-size: 16px; outline: none; background: transparent; }' +
        '.date-input { width: 50px; display: inline-block; text-align: center; margin: 0 2px; }' +
        '.signature-section { width: 100%; }' +
        '.signature-row { margin-bottom: 5px;display: flex;align-items: center;justify-content:flex-end; }' +
        '.signature-row.left-align { text-align: left; }' +
        '.signature-image { display: inline-block; vertical-align: middle; max-width: 150px; max-height: 40px; cursor: pointer; }' +
        '.signature-placeholder { display: inline-block; vertical-align: middle; cursor: pointer; min-width: 150px; min-height: 40px; }' +
        'textarea { resize: vertical; min-height: 80px; }' +
        '.approval-textarea { min-height: 60px; }' +
        '@media print { body { padding: 0; } }' +
        '</style></head><body>' +
        element.outerHTML +
        '<script>window.onload = function() { window.print(); window.onafterprint = function() { window.close(); }; }<' + '/script></body></html>'
      printWindow.document.write(htmlContent)
      printWindow.document.close()
    }
  }
}
</script>

<style lang="less" scoped>
.withdrawal{
  min-height: 100%;
  .log-card{
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    min-height: 100%;
    .page-header{
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .page-title{
        font-size: 20px;
        color: #333333;
        font-weight: bold;
      }
    }
    .action-buttons{
      display: flex;
      gap: 12px;
    }
    .form-container{
      padding: 20px;
      border-radius: 8px;
      overflow-x: auto;
      .form-header{
        .header-line1{
          text-align: center;
          font-size: 28px;
          color: #666667;
          margin-bottom: 10px;
        }
        .header-line3{
          font-size: 16px;
          color: #666667;
          line-height: 25px;
        }
        .date-row{
          position: relative;
          display: flex;
          justify-content: flex-start;
          span:last-child{
            position: absolute;
            left: 60%;
          }
        }
        .text{
          text-indent: 2em;
        }
      }
    }
    .application-table{
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      tbody{
        tr{
          td{
            border: 1px solid #000;
            padding: 10px;
            vertical-align: middle;
            height: 45px;
            font-size: 16px;
            &.label{
              color: #333;
              text-align: left;
              border: 1px solid #000;
              text-align: center;
            }
            input, select, textarea{
              width: 100%;
              padding: 8px;
              border: none;
              font-size: 16px;
              outline: none;
              background: transparent;
            }
            .date-input{
              width: 50px;
              display: inline-block;
              text-align: center;
              margin: 0 2px;
            }
            .signature-section{
              width: 100%;
            }
            .signature-row{
              margin-bottom: 5px;
              display: flex;
              align-items: center;
              justify-content:flex-end;
              &.left-align{
                text-align: left;
              }
            }
            .signature-image{
              display: inline-block;
              vertical-align: middle;
              max-width: 150px;
              max-height: 40px;
              cursor: pointer;
            }
            .signature-placeholder{
              display: inline-block;
              vertical-align: middle;
              cursor: pointer;
              min-width: 150px;
              min-height: 40px;
            }
            textarea{
              resize: vertical;
              min-height: 80px;
            }
            .approval-textarea{
              min-height: 60px;
            }
          }
        }
      }
    }
  }
}
</style>
